/**
 * Preferences Store (PREF-001)
 * Manages user preferences for anonymous users with localStorage persistence
 * For logged-in users, preferences come from backend via authStore
 */
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { withStorageSync } from './utils/withStorageSync';

/** Supported currencies */
export type SupportedCurrency = 'ARS' | 'USD' | 'EUR' | 'BRL';

/** Default currency for Argentina market */
export const DEFAULT_CURRENCY: SupportedCurrency = 'ARS';

interface PreferencesState {
  /** Currency preference for anonymous users */
  currency: SupportedCurrency;

  /** Set currency preference */
  setCurrency: (currency: SupportedCurrency) => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      currency: DEFAULT_CURRENCY,

      setCurrency: (currency) => set({ currency }),
    }),
    {
      name: 'core-preferences',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

// Enable cross-tab sync (PREF-001)
if (typeof window !== 'undefined') {
  withStorageSync(usePreferencesStore);
}
